// removed by extract-text-webpack-plugin
module.exports = {"root":"style__root___3F4_9","Info":"style__Info___PWS07","InfoTitle":"style__InfoTitle___1WsOZ","InfoSubTitle":"style__InfoSubTitle___1qzSu","Rectangle":"style__Rectangle___3d1AG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientCollection/NoPage/style.scss
// module id = 1398
// module chunks = 0